module.exports = __webpack_public_path__ + "files/3d786167aa1da29ffd4dbfb0ff360884.png";